import * as actionTypes from "../actionTypes/actionTypes";
import {
  createNewModelService,
  getModelsService,
  deleteModelService,
  createRepTextService,
  deleteRepTextService,
  saveRepTextService,
  getRegionsService,
  saveModelService,
  salesOfficeFetch,
  marketOfficeFetch,
  createNewRegionService,
  updateRegionSalesMarketService,
  addNewMarketService,
  currencyFetch,
  createNewSalesOfficeService,
  updateSalesOfficeService
} from "../services/ModelsService";
import * as _ from "lodash";

const setShowPanel = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SHOW_SIDE_PANEL,
      payload: requestPayload
    })
  }
}

const setModelSelectedPage = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_MODEL_PAGE,
      payload: requestPayload
    })
  }
}

const getModels = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_MODELS
        })
        window.startLoading();
        getModelsService()
        .then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_MODELS_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.DELETE_MODEL_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const deleteModel = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_MODEL
      })
      window.startLoading();
      await deleteModelService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_MODEL_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_MODEL_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const createNewModel = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_MODEL,
    });
    await createNewModelService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_MODEL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_MODEL_FAILURE,
          payload: error,
        });
      });
  };
};

const updateModel = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_MODEL,
    });
    await saveModelService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_MODEL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_MODEL_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteAdminService = (requestPayload,type) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_REGION
      })
      await deleteModelService(requestPayload,type)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_REGION_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_REGION_FAILURE,
              payload: error
          })
      })
  }
}

const createRepText = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_REPTEXT,
    });
    await createRepTextService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.CREATE_NEW_REPTEXT_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_REPTEXT_FAILURE,
          payload: error,
        });
      });
  };
};

const updateRepText = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_REPTEXT,
    });
    await saveRepTextService(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_REPTEXT_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_REPTEXT_FAILURE,
          payload: error,
        });
      });
  };
};

const getRegions = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_REGIONS
      })
      await getRegionsService()
      .then((response) => {
          const data = response.data;
          dispatch({
              type: actionTypes.GET_REGIONS_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.GET_REGIONS_FAILURE,
              payload: error
          })
      })
  }
}

const getRegionsT = () => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.GET_REGIONST
    })
    window.startLoading();
    await getRegionsService()
    .then((response) => {
      const data = response.data;
      const sortedRegions = _.sortBy(data, ['regionName']);
      console.log('model action test',sortedRegions);
      dispatch({
        type: actionTypes.GET_REGIONST_SUCCESS,
        payload: sortedRegions
      })
    })
    .catch((error)=>{
      dispatch({
        type:actionTypes.GET_REGIONST_FAILURE,
        payload:error
      })
    }).finally(()=>{
      window.stopLoading();
    })
  }
}

const getSalesOffice = (region) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.GET_SALES_OFFICE
    })
    window.startLoading();
    await salesOfficeFetch(region)
    .then((response) =>{
      const data = response.data;
      const sortedSalesOffice = _.sortBy(data, ['salesOfficeName']);
      dispatch({
        type:actionTypes.GET_SALES_OFFICE_SUCCESS,
        payload:sortedSalesOffice
      })
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.GET_SALES_OFFICE_FAILURE,
        payload:error
      })
    }).finally(()=>{
      window.stopLoading();
    })
  }
}
const getMarket = (sales) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.GET_MARKET
    })
    window.startLoading();
    await marketOfficeFetch(sales)
    .then((response) => {
      const data = response.data;
      const sortedMarket = _.sortBy(data, ['marketName']);
      dispatch({
        type:actionTypes.GET_MARKET_SUCCESS,
        payload:sortedMarket
      })
    })
    .catch((error)=>{
      dispatch({
        type:actionTypes.GET_MARKET_FAILURE,
        payload:error
      })
    }).finally(()=>{
      window.stopLoading();
    })
  }
}

const addNewRegion = (regionName) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.ADD_REGION
    })
    await createNewRegionService(regionName)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.ADD_REGION_SUCCESS,
        payload:data
      })
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.ADD_REGION_FAILURE,
        payload:error
      })
    })
  }
}

const updateRegionSalesMarket = (data,type) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.UPDATE_REGION_SALES_MARKET_START
    })
    await updateRegionSalesMarketService(data,type)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.UPDATE_REGION_SALES_MARKET_SUCCESS,
        payload:data
      })
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.UPDATE_REGION_SALES_MARKET_FAILURE,
        payload:error
      })
    })
  }
}

const addNewMarket = (data) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.ADD_NEW_MARKET_START
    })
    await addNewMarketService(data)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.ADD_NEW_MARKET_SUCCESS,
        payload:data
      })
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.ADD_NEW_MARKET_FAILURE,
        payload:error
      })
    })
  }
}

const getCurrency = () => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CURRENCY_FETCH_START
    })
    await currencyFetch()
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.CURRENCY_FETCH_SUCCESS,
        payload:data
      })
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.CURRENCY_FETCH_FAILURE,
        payload:error
      })
    })
  }
}

const createNewSalesOffice = (payload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.ADD_NEW_SALES_OFFICE_START
    })
    await createNewSalesOfficeService(payload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.ADD_NEW_SALES_OFFICE_SUCCESS,
        payload:data
      })
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.ADD_NEW_SALES_OFFICE_FAILURE,
        payload:error
      })
    })
  }
}

const updateSalesOffice = (payload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_SALES_OFFICE_STARTED
    })
    await updateSalesOfficeService(payload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type: actionTypes.UPDATE_SALES_OFFICE_SUCCESS,
        payload: data
      })
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.UPDATE_SALES_OFFICE_FAILURE,
        payload:error
      })
    })
  }
}


export { setShowPanel, getModels, deleteModel, createNewModel, updateModel, createRepText, updateRepText, getRegions, setModelSelectedPage,getRegionsT,getSalesOffice,getMarket,addNewRegion,deleteAdminService,updateRegionSalesMarket,addNewMarket,getCurrency,createNewSalesOffice,updateSalesOffice};
